export const MODULE_NAME = 'appRecommendation';
